import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true, // attaches httpOnly auth_token cookie automatically
});

// Phase 10c-F: legacy localStorage token read interceptor removed. Auth is now
// 100% cookie-driven (httpOnly auth_token + Emergent session_token). The cookie
// is attached automatically via withCredentials. No JavaScript-readable token
// surface remains — XSS exfil of auth tokens is no longer possible.

api.interceptors.response.use(
  (r) => r,
  (err) => {
    // Defensive cleanup: nuke any pre-migration token left in localStorage so
    // older browser sessions don't keep one around. Safe no-op if absent.
    if (err?.response?.status === 401) {
      const url = err.config?.url || "";
      if (!url.endsWith("/auth/me")) {
        try { localStorage.removeItem("teebee_token"); } catch { /* ignore */ }
      }
    }
    return Promise.reject(err);
  }
);

export default api;
